import { addClass, removeClass } from '@utils/domUtils';

import {
  createJobAdValidations,
  createGeneralValidations,
} from '@components/JobCreateWizard/validations';

import Validator from './Validator';

export default function validateUpdateJob(form) {
  const generalSettingsCard = form.querySelector('.general-settings-card');
  const generalSettingsCardErrorMarker = generalSettingsCard.querySelector('.block-error-marker');
  const generalValidator = createGeneralValidations(form);
  const validations = [createJobAdValidations(form), generalValidator];

  generalValidator.on('core.element.validated', async event => {
    if ([...form.querySelectorAll('.has-danger')].length === 0) {
      removeClass(generalSettingsCard, 'border-danger');
      addClass(generalSettingsCardErrorMarker, 'hide');
    } else {
      addClass(generalSettingsCard, 'border-danger');
      removeClass(generalSettingsCardErrorMarker, 'hide');
    }
  });

  return new Validator(validations);
}
